module.exports = __webpack_public_path__ + "57cc32ed94ea8c90afea9cc1b846087d.png";